export default "__VITE_ASSET__41862568__"